import LLGlobeTrotter from '@/locales/GlobeTrotter/en';
import LLTrendingNow from '@/locales/TrendingNow/en';
import LLEdito from '@/locales/Edito/en';
import LLTravel from '@/locales/Travel/en';
import LLTune from '@/locales/Tune/en';
import LLFuture from '@/locales/Future/en';
import LLArtyWilmotte from '@/locales/ArtyWilmotte/en';
import LLArtyMirror from '@/locales/ArtyMirror/en';
import LLKeyReport from '@/locales/KeyReport/en';
import LLEntrepreneurs from '@/locales/Entrepreneurs/en';
import LLEssential from '@/locales/Essential/en';
import LLWayISeeIt from '@/locales/WayISeeIt/en';
import LLLegal from '@/locales/Legal/en';

export const  en = {

    // les éléments du menu
    // pour l'edito, vu qu'il est variable en fonction du marché (present dans l'url), la structure est un peu différente
    menu: {
        EditoEN: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoMC: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoCH: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoLU: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoUK: {
            segment: 'editorial',
            title: 'Editorial',
        },
        EditoFR: {
            segment: 'editorial',
            title: 'Editorial',
        },
        Essential: {
            segment: 'essentials',
            title: 'Essentials',
        },
        WayISeeIt: {
            segment: 'the-way-i-see-it',
            title: 'The way i see it',
        },
        TrendingNow: {
            segment: 'trending-now',
            title: 'Trending Now',
        },
        GlobeTrotter: {
            segment: 'globe-trekker',
            title: 'Globe trekker',
        },
        Travel: {
            segment: 'county-galway-every-sens-jerome-galland',
            title: 'County Galway in every sense with Jérôme Galland',
        },
        Tune: {
            segment: 'in-tune-with-christophe-rousset',
            title: 'Christophe Rousset’s aesthetic wager',
        },
        Future: {
            segment: 'being-happier-with-less',
            title: 'Being happier with less?',
        },
        ArtyMirror: {
            segment: 'the-other-side-of-the-mirror',
            title: 'On the other side of the mirror',
        },
        ArtyWilmotte: {
            segment: 'the-world-of-jean-michel-wilmotte',
            title: 'The world of Jean-Michel Wilmotte',
        },
        KeyReport: {
            segment: 'is-plastic-on-the-way-out',
            title: 'Is plastic on the way out?',
        },
        Entrepreneurs: {
            segment: 'christine-vernay-woman-of-land',
            title: 'Christine Vernay, a woman of the land',
        },
        Legal: {
            segment: 'credits-legal-information',
            title: 'Credits & legal information',
        },

    },

    // les différentes pages, on scinde en fichiers, sinon ca va être trop long et chiant a contribuer

    Essential: LLEssential,

    EditoEN: LLEdito,
    EditoMC: LLEdito,
    EditoCH: LLEdito,
    EditoLU: LLEdito,
    EditoUK: LLEdito,
    EditoFR: LLEdito,

    TrendingNow: LLTrendingNow,

    GlobeTrotter: LLGlobeTrotter,

    Travel: LLTravel,
    Tune: LLTune,

    Future: LLFuture,

    ArtyWilmotte: LLArtyWilmotte,
    ArtyMirror: LLArtyMirror,

    KeyReport: LLKeyReport,

    Entrepreneurs: LLEntrepreneurs,

    WayISeeIt: LLWayISeeIt,

    Legal: LLLegal,

    home: {
        logoBaseLine: 'PB, see the world differently&nbsp;with <br />Societe&nbsp;Generale Private&nbsp;Banking <br />Summer 2020 #4',
        logoBaseLineKH: 'PB, see the world differently&nbsp;with <br />Kleinwort&nbsp;Hambros <br />Summer 2020 #4',
        title: 'Christine Vernay, a woman of the land',
        artitle1title: 'Shapers of the future',
        artitle1content: 'Frugal and low-tech innovation:  ways to do better with less',
        artitle2title: 'Key report',
        artitle2content:  'Is plastic on the way out?',
        artitle3title: 'A new take on travel',
        artitle3content:  'County Galway in every sense with Jérôme Galland ',
    },

    next: 'Next: ',

    welcome_message : 'EN - Welcome to Your Vue.js App',
    popular_links : 'EN - Popular Links',
    ecosystem : 'EN - Ecosystem',
    test: {
        toto: 'toto label',
        tutu: 'tutu label',
        titi: {
            test: 'titi label',
        },
    },
    counterUpSeparator: ',',
    counterUpDecimal: '.',
};
